import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AuthStore } from '@store';

import { SubscriptionPlan } from '@vi-iot/client';
import { BookingPlansSpecification } from './booking-plans-specification';

@Component({
  selector: 'app-booking-plans-spec',
  templateUrl: './booking-plans-spec.component.html',
  styleUrls: ['./booking-plans-spec.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingPlansSpecComponent {
  readonly subscriptionsPlanType = SubscriptionPlan;
  readonly bookingPlansSpecification = BookingPlansSpecification;

  constructor(public authStore: AuthStore) {}
}
